import { type Cell, type RowData, flexRender } from "@tanstack/react-table";

import { type DataGridColumnDef } from "../useColumnState";

export type RenderedCellProps<T extends RowData> = {
	cell: Cell<T, unknown>;
	groupIndices?: number[];
};
export function RenderedCell<T>({ cell }: RenderedCellProps<T>) {
	const columnDef = cell.column.columnDef as DataGridColumnDef<T, unknown>;

	return flexRender(columnDef.cell, { ...cell.getContext() });
}
